<template>
  <div>
    <div class="content">

      <div class="sidebar">
        <ul>
          <li>
            <a href="javascript:void(0)" @click="cate = ''" :class="{ 'active': cate == '' }">
              <img src="/static/img/icon/1055814.png" alt="">
              <p>หน้าแรก</p>
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" @click="cate = 'SLOT'" :class="{ 'active': cate == 'SLOT' }">
              <img src="/static/img/icon/2108661.png" alt="">
              <p>รวมค่าย สล็อต</p>
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" @click="cate = 'CASINO'" :class="{ 'active': cate == 'CASINO' }">
              <img src="/static/img/icon/2108630.png" alt="">
              <p>รวมค่าย คาสิโนสด</p>
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" @click="cate = 'POKER'" :class="{ 'active': cate == 'POKER' }">
              <img src="/static/img/icon/menu-poker.png" alt="">
              <p>รวม ไพ่</p>
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" @click="cate = 'TRADDING'" :class="{ 'active': cate == 'TRADDING' }">
              <img src="/static/img/icon/history.png" alt="">
              <p>รวมค่าย เทรด</p>
            </a>
          </li>

          <li>
            <a href="javascript:void(0)" @click=" changeCat(cate = 'promo', '/promotion')"
            :class="{ 'active': cate == 'promo' }">
              <img src="/static/img/icon/5002461.png" alt="">
              <p>โปรโมชั่น</p>
            </a>
          </li>
        </ul>
      </div>
      <div class="menu_bar mySwiper_2 swiper-initialized swiper-horizontal">
        <div class="container swiper-wrapper" id="swiper-wrapper-7c16d4429e4b53a7" aria-live="polite"
          style="transition-duration: 0ms;">
          <div class="item swiper-slide swiper-slide-duplicate" data-swiper-slide-index="3">
            <a href="#">
              <img src="/static/img/icon/2108661.png" alt="">
              <p>สล็อต</p>
            </a>
          </div>
          <div class="item swiper-slide swiper-slide-duplicate" data-swiper-slide-index="4">
            <a href="#">
              <img src="/static/img/icon/2108630.png" alt="">
              <p>คาสิโนสด</p>
            </a>
          </div>
          <div class="item swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active" data-swiper-slide-index="5">
            <a href="#">
              <img src="/static/img/icon/menu-poker.png" alt="">
              <p>ไพ่</p>
            </a>
          </div>
          <div class="item swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active" data-swiper-slide-index="5">
            <a href="#">
              <img src="/static/img/icon/history.png" alt="">
              <p>เทรด</p>
            </a>
          </div>

          <div class="item swiper-slide swiper-slide-duplicate" data-swiper-slide-index="7">
            <a href="javascript:void(0)" @click=" changeCat(cate = 'promo', '/promotion')"
            :class="{ 'active': cate == 'promo' }">
              <img src="/static/img/icon/5002461.png" alt="">
              <p>โปรโมชั่น</p>
            </a>
          </div>

        </div>
        <div class="swiper-button-next" tabindex="0" role="button" aria-label="Next slide"
          aria-controls="swiper-wrapper-7c16d4429e4b53a7"></div>
        <div class="swiper-button-prev" tabindex="0" role="button" aria-label="Previous slide"
          aria-controls="swiper-wrapper-7c16d4429e4b53a7"></div>
        <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
      </div>
      <div class="container_content">



        <div class="news">
          <marquee style="color: #ffffff" scrollamount="5" loop="infinite">FastSpin345.com เกมส์สล็อตออนไลน์ที่มีครบวงจรที่ดีที่สุด 
          ปลอดภัยจ่ายจริง ระบบฝาก-ถอน ผ่านระบบAuto </marquee>
        </div>

        <div v-if="cate == 'SLOT' || cate == ''" class="game_slot">
          <div class="header_slot">
            <img src="/static/img/icon/2108661.png" alt="">
            <p>รวมค่าย สล็อต</p>
          </div>
          <div class="game">
            <img v-for="(item, index) in getGameList.ImageSlot" :key="`Slot-${index}`" :src="item.img" alt="">

          </div>
        </div>
        <div v-if="cate == 'CASINO' || cate == ''" class="game_casino">
          <div class="header_casino">
            <img src="/static/img/icon/2108630.png" alt="">
            <p>รวมค่าย คาสิโนสด</p>
          </div>

          <div class="game">
            <img v-for="(item, index) in getGameList.ImageCasino" :key="`Casino-${index}`" :src="item.img" alt="">

          </div>
        </div>

        <div v-if="cate == 'POKER' || cate == ''" class="game_slot">
          <div class="header_slot">
            <img src="/static/img/icon/menu-poker.png" alt="">
            <p>รวมค่าย ไพ่</p>
          </div>
          <div class="game">
            <img v-for="(item, index) in getGameList.ImagePOKER" :key="`Poker-${index}`" :src="item.img" alt="">

          </div>
        </div>

        <div v-if="cate == 'TRADDING' || cate == ''" class="game_slot">
          <div class="header_slot">
            <img src="/static/img/icon/history.png" alt="">
            <p>รวมค่าย เทรด</p>
          </div>
          <div class="game">
            <img v-for="(item, index) in getGameList.ImageTRADING" :key="`Tradding-${index}`" :src="item.img" alt="">

          </div>
        </div>

      </div>
    </div>

    <div class="seo">
      <div class="container_seo">
        <img src="/static/img/icon/123213.png" alt="">
        <p>
          JaiJai.com เกมส์ สล็อตออนไลน์ที่มีความสนุกสนาน และมีโอกาสชนะสูง ครบวงจรที่ดีที่สุด ปลอดภัย
          จ่ายจริง ระบบฝาก-ถอน ผ่านระบบAuto แบบAi100% ตลอด24ชม ทำรายการภายใน 5 วินาที
          มีหมวดหมู่เดิมพันให้บริการหลากหลายที่สุด เช่น คาสิโนสด บาคาร่า รุเล็ต เสือมังกร จัดเต็มให้บริการ
          มากกว่า8ค่าย สล็อตออนไลน์,ยิงปลาออนไลน์,เกมไพ่ออนไลน์อีกมากมาย กับ38ค่ายเกม FastSpin345
          เลือกทำเงินกับอัตราการจ่ายสูงสุดถึง 98% ทุกค่าย
          จัดเต็มไว้ให้บริการที่นี่แล้ว โปร่งใสทุกการเดิมพัน พร้อมการรันตีจากคาสิโนโดยตรง มีประสบการณ์มากกว่า 20
          ปี มั่นคง ปลอดภัยด้านการเงินที่สุด </p><br>
        <p>
        </p>
      </div>
    </div>

    <div class="swiper_con">
      <div class="header">
        <p>ค่ายเกมต่างๆ</p>
      </div>
      <!-- Swiper -->
      <swiper class="mySwiper" v-bind="swiperOptions">
        <swiper-slide v-for="(item, i) in getGameList.all" :key="i">

          <img :src="item.img" width="100%">

        </swiper-slide>

      </swiper>


    </div>

    <div class="text_footer">
      <p class="text_1">มั่นคง ปลอดภัย 100%</p>
      <p class="text_2">
        ทีมงานบริการ 24 ชั่วโมง ทำรายการไม่เกิน 1 นาที ฝากถอนออโต้
      </p>
      <img src="/static/img/icon/12321342323.png" alt="">
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getPrefix } from "@/services/modules/global.js";
import { reward } from "@/config/reward.js";
import carousel from "vue-owl-carousel";
import LoginForm from "@/components/form/LoginForm";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

import RegisterForm from "@/components/form/RegisterForm";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
// import carousel from "vue-owl-carousel";

import { EffectCoverflow, Navigation, Pagination, Autoplay } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";
import "swiper/swiper-bundle.css";
SwiperCore.use([Navigation, Pagination, Autoplay, EffectCoverflow]);
// import "swiper/components/effect-coverflow/effect-coverflow.min.css";
import "swiper/components/effect-coverflow/effect-coverflow.min.css";
import api from "@/services/index.js";
import MarqueeText from "vue-marquee-text-component";

export default {
  name: "Index",

  data() {
    return {
      slickSetting: {
        "dots": true,
        "infinite": false,
        "speed": 500,
        "slidesToShow": 5.5,
        "slidesToScroll": 5.5,
        "initialSlide": 0,
        "responsive": [
          {
            "breakpoint": 1920,
            "settings": {
              "slidesToShow": 5.5,
              "slidesToScroll": 5.5,
            }
          },
          {
            "breakpoint": 1680,
            "settings": {
              "slidesToShow": 5.5,
              "slidesToScroll": 5.5,
            }
          },
          {
            "breakpoint": 1280,
            "settings": {
              "slidesToShow": 5.5,
              "slidesToScroll": 5.5,
            }
          },
          {
            "breakpoint": 1152,
            "settings": {
              "slidesToShow": 4.5,
              "slidesToScroll": 4.5,
            }
          },
          {
            "breakpoint": 1024,
            "settings": {
              "slidesToShow": 4,
              "slidesToScroll": 4,
            }
          },
          {
            "breakpoint": 832,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 3,
            }
          },
          {
            "breakpoint": 600,
            "settings": {
              "slidesToShow": 3,
              "slidesToScroll": 3,
            }
          },
          {
            "breakpoint": 480,
            "settings": {
              "slidesToShow": 1.5,
              "slidesToScroll": 1.5,
            }
          },
          {
            "breakpoint": 320,
            "settings": {
              "slidesToShow": 1,
              "slidesToScroll": 1
            }
          }
        ]
      },
      phoneNumber: "",
      password: "",
      showpass: false,
      remember: false,
      showHeader: false,
      gameTab: 0,
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 10,
        centeredSlides: true,
        breakpoints: {
          320: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 7,
            spaceBetween: 10,
          },
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        loop: true,
      },
      swiperGameOptions: {
        loop: false,
        slidesPerView: 4,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: false,
        spaceBetween: 0,
        // navigation: false,
        navigation: {
          nextEl: ".slick-prev-btn",
          prevEl: ".slick-next-btn",
        },
      },
      swiperPromotionOptions: {
        loop: false,
        slidesPerView: "auto",
        navigation: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        spaceBetween: 0,
      },
      swiperWinnerOptions: {
        loop: false,
        slidesPerView: "auto",
        navigation: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        spaceBetween: 0,
        pagination: {
          el: ".winner-active-page",
          type: "fraction",
        },
      },
      swiperTopOptions: {
        loop: false,
        slidesPerView: "auto",
        // navigation: false,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        centeredSlides: true,
        spaceBetween: 0,
        navigation: {
          nextEl: ".provider-next-btn",
          prevEl: ".provider-prev-btn",
        },
      },
      availableBalance: "Loading...",
      availableCredit: "Loading...",
      isShowGame: true,
      chList: [],
      gameList: [],
      inGameList: false,
      ischName: "บริการของเรา",
      havelink: 0,
      gameListChunk: [],
      gameType: true,
      gameCH: this.$route.params.ch,
      chSlotList: [],
      gameCH: undefined,
      gameImg: "",
      gameType: "",
      gameCategory: "",
      productId: "",
      cate: "",
      category:
        this.$route.params.category == undefined
          ? "Casino"
          : this.$route.params.category,
      tab: 1,
    };
  },

  components: {
    Header,
    Swiper,
    SwiperSlide,
    VueSlickCarousel,
    Footer,
    MarqueeText,
    carousel
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "appTitle",
    ]),
  },
  methods: {
    ...mapActions(["userSignIn", "setError"]),
    gotoRoute(route) {
      this.$router.push(route);
    },
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
    gotoCategory(category) {
      this.inGameList = false;
      this.category = category;
      this.$router.push(`/play/${category}`).catch(() => { });
    },

    gotoSub(route, item) {
      (this.gameImg = item.img
        .replace("game", "game_tranparent")
        .replace("game_betflik", "game_betflik_tranparent")),
        (this.gameType = item.gameType),
        (this.gameCategory = item.gameCategory),
        this.getGames(item.ch, item.gameType, item.category);
    },
    // async getChannels() {
    //   console.log("getChannels");

    //   await api
    //     .get("/user-profile-composite/v1/products")
    //     .then((v) => {
    //       if (v.success == true) {
    //         this.chList = v.data;
    //       } else {
    //         this.$swal.fire("แจ้งเตือน", v.message, "error");
    //       }
    //     })
    //     .catch((e) => {
    //       this.$swal.fire("แจ้งเตือน", e.message, "error");
    //     })
    //     .finally(() => {});
    // },
    async LoginGame(gameCode) {
      setTimeout(async () => {
        await api
          .get(`/user-profile-composite/v1/logIn/${this.productId}/${gameCode}`)
          .then((v) => {
            if (v.success == true) {
              if(v.data.url){
                setTimeout("location.href = '" + v.data.url + "';", 100);
              }else{
                this.$swal.fire("ไม่พบตัวเกม กรุณาลองใหม่อีกครั้ง", "", "error");
              }
            } else {
              this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            this.$swal.fire("แจ้งเตือน", e.message, "error");
          })
          .finally(() => { });
      }, 3000);
    },
    async getGames(chId, filter = "-", category) {
      console.log(chId, filter, category);

      console.log("getGames 1");

      const AccessToken = localStorage.getItem("AccessToken");

      var thisGame = this.chList.find(
        (x) => x.ProductId == chId && x.gameType == filter
      );
      console.log("getGames 2");

      if (thisGame != undefined) {
        console.log("getGames 3");
        filter = thisGame.gameType;
        if (filter == "LOBBY") {
          console.log("LOBBY");
          console.log(filter);

          this.productId = chId;
          this.gameCH == undefined;
          // this.$router.push(`/play/${this.category}`).catch(() => { });
          return this.LoginGame(chId);
        }
        console.log("NO LOBBY");
        console.log(filter);
        await api
          .get(
            `/user-profile-composite/v1/games/${thisGame.ProductId}/${filter}`
          )
          .then((v) => {
            if (v.success == true) {
              if (filter == "*") {
                this.gameList = v.data.games;
              } else {
                this.gameList = v.data.games.filter(
                  (x) => x.category == filter
                );
              }
              this.inGameList = true;
              this.productId = chId;
              this.gameCategory = category;
              this.gameCH = chId;

              // this.$router.push(`/play/${this.category}/${chId}`).catch(() => { });

              // this.gameImg = this.getGamesImg(chId, category)
            } else {
              if (v.message) {
                if (v.message.message) {
                  return this.$swal.fire(v.message.message[0], "", "error");
                }
                return this.$swal.fire(v.message, "", "error");
              }
              return this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            if (e.message) {
              if (e.message.message) {
                this.$swal.fire(e.message.message[0], "", "error");
              } else {
                this.$swal.fire(e.message, "", "error");
              }
            } else {
              return this.$swal.fire("แจ้งเตือน", e.message, "error");
            }
          })
          .finally(() => { });
      }
    },

    async getGamesPage(chId, filter = "-", category) {
      console.log(chId, filter, category);

      console.log("getGames 1");

      const AccessToken = localStorage.getItem("AccessToken");

      var thisGame = this.chList.find(
        (x) => x.ProductId == chId && x.gameType == filter
      );
      console.log("getGames 2");

      if (thisGame != undefined) {
        console.log("getGames 3");
        filter = thisGame.gameType;
        if (filter == "LOBBY") {
          console.log("LOBBY");
          console.log(filter);

          this.productId = chId;
          this.gameCH == undefined;
          // this.$router.push(`/play/${this.category}`).catch(() => { });
          return this.LoginGame(chId);
        }

        await api
          .get(
            `/user-profile-composite/v1/games/${thisGame.ProductId}/${filter}`
          )
          .then((v) => {
            if (v.success == true) {
              if (filter == "*") {
                this.gameList = v.data.games;
              } else {
                this.gameList = v.data.games.filter(
                  (x) => x.category == filter
                );
              }
              this.inGameList = true;
              this.productId = chId;
              this.gameCategory = category;
              this.gameCH = chId;

              this.$router
                .replace(`/play/${this.category}/${filter}/${chId}`)
                .catch(() => { });
              // this.$router.push(`/play/${this.category}/${chId}`).catch(() => { });

              // this.gameImg = this.getGamesImg(chId, category)
            } else {
              if (v.message) {
                if (v.message.message) {
                  return this.$swal.fire(v.message.message[0], "", "error");
                }
                return this.$swal.fire(v.message, "", "error");
              }
              return this.$swal.fire("แจ้งเตือน", v.message, "error");
            }
          })
          .catch((e) => {
            if (e.message) {
              if (e.message.message) {
                this.$swal.fire(e.message.message[0], "", "error");
              } else {
                this.$swal.fire(e.message, "", "error");
              }
            } else {
              return this.$swal.fire("แจ้งเตือน", e.message, "error");
            }
          })
          .finally(() => { });
        // this.$router.push({ name: 'play', params: { category: this.category } });
        // this.$router.replace(`/play/${this.category}/${filter}/${chId}`).catch(() => { });
      }
    },
  },
  async mounted() {
    this.setError(null);
    if (localStorage.getItem("remember.username") != null) {
      this.phoneNumber = localStorage.getItem("remember.username");
      this.remember = true;
    }
    if (localStorage.getItem("remember.password") != null) {
      this.password = localStorage.getItem("remember.password");
      this.remember = true;
    }

    // await this.getChannels();

    if (this.$route.params.category != undefined) {
      this.category = this.$route.params.category;
      console.log(this.$route.params.category);

      if (
        this.$route.params.ch == undefined &&
        this.$route.params.gameType == undefined
      ) {
        console.log("chchch");
      } else {
        this.category = this.$route.params.category;
        this.inGameList = true;
        console.log("gameTypegameTypegameType");
        console.log(this.$route.params.gameType);
        console.log(this.$route.params.ch);
        this.getGames(
          this.$route.params.ch,
          this.$route.params.gameType,
          this.$route.params.category
        );
      }
    }
  },
};
</script>

 


// WEBPACK FOOTER //
// src/pages/index/views/Index.vue